import React from "react";
import {
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const searchData = this.props.searchData;
    const chequeCustomerData = this.props.chequeCustomerData;
    const total = this.props.total;
    const newSelectedMonth = this.props.newSelectedMonth;
    const newSelectedYear = this.props.newSelectedYear;

    return (
      <div>
        <div style={{ width: '1093px', height: '1059px', padding: '20px', marginBottom: "14rem" }}>
          <br />
          <h2><center><u>Cheque Customer Details Report</u></center></h2>
          <div>&nbsp;</div>
          <h4><center>BOUGHT LEAF DIRECT CHEQUE PAYMENT FOR THE MONTH OF {newSelectedMonth} - {newSelectedYear}</center></h4>
          <div>&nbsp;</div>
          <h3><center>Group: {searchData.groupName}</center></h3>
          <h3><center>Factory: {searchData.factoryName}</center></h3>
          <h3><center>Route: {searchData.routeName == undefined ? 'All Routes' : searchData.routeName}</center></h3>
          <div>&nbsp;</div>
          <div>&nbsp;</div>
          <div>
            <Box minWidth={1050}>
              <TableContainer>
                <Table size="small" style={{ border: '1px solid #ccc', borderCollapse: 'collapse' }}>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" style={{ border: '1px solid #ccc', fontSize: '14px' }}>Route Name</TableCell>
                      <TableCell align="center" style={{ border: '1px solid #ccc', fontSize: '14px' }}>Reg No</TableCell>
                      <TableCell align="center" style={{ border: '1px solid #ccc', fontSize: '14px' }}>Customer Name</TableCell>
                      <TableCell align="center" style={{ border: '1px solid #ccc', fontSize: '14px' }}>Amount (Rs)</TableCell>
                    </TableRow>
                  </TableHead>
                  {chequeCustomerData.map((data, index) => (
                    <TableBody>
                      <TableRow key={index}>
                        <TableCell align="left" style={{ border: '1px solid #ccc', fontSize: '14px' }}>{data.routeName}</TableCell>
                        <TableCell align="left" style={{ border: '1px solid #ccc', fontSize: '14px' }}>{data.registrationNumber}</TableCell>
                        <TableCell align="left" style={{ border: '1px solid #ccc', fontSize: '14px' }}>{data.name}</TableCell>
                        <TableCell align="right" style={{ border: '1px solid #ccc', fontSize: '14px' }}>{(data.amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                      </TableRow>
                    </TableBody>
                  ))}

                  <TableRow>
                    <TableCell align="left" style={{ border: '1px solid #ccc', fontSize: '14px' }}><b>Total</b></TableCell>
                    <TableCell align="left" style={{ border: '1px solid #ccc', borderRight: 'none', fontSize: '14px' }}></TableCell>
                    <TableCell align="left" style={{ border: '1px solid #ccc', borderLeft: 'none', fontSize: '14px' }}></TableCell>
                    <TableCell align="right" style={{ border: '1px solid #ccc', fontSize: '14px' }}><b>{(total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                  </TableRow>
                </Table>
              </TableContainer>
            </Box>
          </div>
          <div>&nbsp;</div>
          <h4><center>*******End of List*******</center></h4>
        </div></div>
    );

  }

}
